import EmptyLayout from '../Empty/EmptyLayout';

export default class LoadingLayout extends EmptyLayout {
    protected supportsBreadcrumbs = false;
}
